export default [{
  path: '/company/group',
  name: 'CompanyGroup',
  component: () => import('@/app/company-group/CompanyGroup'),
  meta: {
    resource: 'companies',
    actions: ['read']
  }
}]
